import React from "react"
import ReactApexChart from "react-apexcharts"

export const SaleseChart = () => {
  const chartOptions = {
    series: [60, 15, 12, 8],
    chart: {
      width: 380,
      type: "donut",
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#C3EBFA", "#FAE27C", "#CFCEFF", "#AAFFF1"],
    labels: ["Purchase", "Salary", "Assets", "Food & Drink"],
    legend: {
      position: "bottom",
      horizontalAlign: "center",
      offsetY: 10,
      height: 100,
      formatter: function (seriesName, opts) {
        const percentages = [60, 15, 12, 8]
        const values = [2100, 525, 420, 280]
        return `${seriesName}: ${percentages[opts.seriesIndex]}% ($${
          values[opts.seriesIndex]
        })`
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            show: true,
          },
        },
      },
    ],
  }
  return (
    <div>
      <div className="d-flex justify-content-center mt-4">
        <ReactApexChart
          options={chartOptions}
          series={chartOptions.series}
          type="donut"
          width={240}
        />
      </div>
      <div className="d-flex justify-content-between mb-3">
        <div className="chartbottom chartbottom-color">60%</div>
        <div>$2,100</div>
      </div>
      <div className="d-flex justify-content-between mb-3">
        <div className="chartbottom chartbottom-co">60%</div>
        <div>$2,100</div>
      </div>
      <div className="d-flex justify-content-between mb-3">
        <div className="chartbottom chartbottom-col">60%</div>
        <div>$2,100</div>
      </div>
      <div className="d-flex justify-content-between mb-3">
        <div className="chartbottom chartbottom-colo">60%</div>
        <div>$2,100</div>
      </div>
    </div>
  )
}

export const DemoChart = () => {
    const chartOptions = {
      series: [10, 20, 60, 10],
      chart: {
        width: 380,
        type: "donut",
      },
      dataLabels: {
        enabled: false,
      },
      colors: ["#C3EBFA", "#FAE27C", "#CFCEFF", "#AAFFF1"],
      labels: ["Purchase", "Salary", "Assets", "Food & Drink"],
      legend: {
        position: "bottom",
        horizontalAlign: "center",
        offsetY: 10,
        height: 100,
        formatter: function (seriesName, opts) {
          const percentages = [10, 20, 60, 10]
          const values = [2100, 525, 420, 280]
          return `${seriesName}: ${percentages[opts.seriesIndex]}% ($${
            values[opts.seriesIndex]
          })`
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              show: true,
            },
          },
        },
      ],
    }
    return (
      <div>
        <div className="d-flex justify-content-center mt-4">
          <ReactApexChart
            options={chartOptions}
            series={chartOptions.series}
            type="donut"
            width={240}
          />
        </div>
        <div className="d-flex justify-content-between mb-3">
          <div className="chartbottom chartbottom-color">60%</div>
          <div>$2,100</div>
        </div>
        <div className="d-flex justify-content-between mb-3">
          <div className="chartbottom chartbottom-co">30%</div>
          <div>$10,100</div>
        </div>
        <div className="d-flex justify-content-between mb-3">
          <div className="chartbottom chartbottom-col">10%</div>
          <div>$1,100</div>
        </div>
        <div className="d-flex justify-content-between mb-3">
          <div className="chartbottom chartbottom-colo">80%</div>
          <div>$211,100</div>
        </div>
      </div>
    )
  }